export const ingridientList = [
  {id: null, label: 'Válassz a listából'},
  {id: 1, label: 'Bulgur', ch: 75.8},
  {id: 2, label: 'Basmati Rizs', ch: 32.8},
  {id: 3, label: 'Tojás', ch: 0},
  {id: 4, label: 'TK Kenyér', ch: 57},
  {id: -1, label: 'Egyêb'},
];
